import React from 'react';
import classNames from 'classnames';
import './StatTiles.styles.scss';
import './StatTiles.styles.responsive.scss';

type TileContent = { text: string; secondaryText: string };
type StatTilesProps = {
  className?: string;
  tiles: TileContent[];
};

const StatTiles: React.FC<StatTilesProps> = (props) => {
  const { tiles, className } = props;

  const classes = classNames('stat-tiles', className);

  return (
    <div className={classes}>
      {tiles.map(({ text, secondaryText }) => (
        <div key={text} className="tile">
          <span>{text}</span> <span>{secondaryText}</span>
        </div>
      ))}
    </div>
  );
};

export default StatTiles;
